<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" />
        </div>

        <div class="mb-5">
          <div class="label-input">Layout</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-container']"
                    @change="event => (fields['card-container'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['card-container']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="event => (fields['text-color'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['text-color']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Media Position</label>
                <v-select
                  :value="fields['card-item-image']"
                  :items="positionOptions"
                  :hide-details="true"
                  class="mt-0"
                  @change="handleChangePosition"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-checkbox
                  v-model="fields['top-padding']"
                  label="Padding top"
                  :hide-details="true"
                  class="mb-2 mt-0"
                />
                <v-checkbox
                  v-model="fields['bottom-padding']"
                  label="Padding bottom"
                  :hide-details="true"
                  class="mb-2 mt-0"
                />
                <v-checkbox
                  v-model="fields['style-center-y']"
                  label="Style center Y"
                  :hide-details="true"
                  class="mb-2 mt-0"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="label-input">Container</div>
          <div class="group-item">
            <v-row class="mb-0">
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="fields['container-page']['show-style']"
                  label="Show Style Container"
                  :hide-details="true"
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-page']['background']"
                    @change="event => (fields['container-page']['background'] = event.target.value)"
                  />
                  <v-text-field v-model="fields['container-page']['background']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex align-center mb-2">
            <label class="label-input mb-0">Card Title</label>
          </div>
          <div class="group-item">
            <div class="">
              <div class="mb-2">
                <v-checkbox
                  v-model="fields['content-title'].show"
                  label="Show title"
                  :hide-details="true"
                  class="mt-0"
                />
              </div>
              <ckeditor :editor="editor" v-model="fields['content-title'].heading" :config="editorConfig" />
            </div>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex align-center mb-2">
            <label class="label-input mb-0">Accordions</label>
            <v-spacer />
            <v-checkbox v-model="fields.accordions.show" :hide-details="true" class="mt-0 mr-2" />
            <v-btn small text color="primary" @click="handleAddAccordion">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.accordions.items" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center w-100">
                    <span>Accordion {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveAccordion(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label>Title</label>
                    <v-text-field v-model="item.title" :hide-details="true" class="mt-0" />
                  </div>
                  <div>
                    <label>Content</label>
                    <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex align-center mb-2">
            <label class="label-input mb-0">Button</label>
            <v-spacer />
            <v-checkbox v-model="fields.button.show" :hide-details="true" class="mt-0" />
          </div>
          <div class="group-item">
            <div>
              <label>Button Text</label>
              <v-text-field v-model="fields.button.text" :hide-details="true" class="mt-0" />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <label>Button Link</label>
                <v-text-field v-model="fields.button.link" :hide-details="true" class="mt-0" />
              </v-col>
              <v-col cols="12" md="6">
                <label>Button Radius</label>
                <v-text-field type="number" v-model="fields.button.radius" :hide-details="true" class="mt-0" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label>Button Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.background"
                    @change="event => (fields.button.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.button.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Button Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.color"
                    @change="event => (fields.button.color = event.target.value)"
                  />
                  <v-text-field v-model="fields.button.color" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Media</div>
          <div class="group-item">
            <div>
              <v-radio-group
                row
                dense
                :value="fields.media['show-image'] ? 'image' : 'video'"
                @change="handleChangeMediaType"
              >
                <v-radio small label="Image" value="image" />
                <v-radio small label="Video" value="video" />
              </v-radio-group>
            </div>
            <div v-if="fields.media['show-image']">
              <UploadImage
                @callback="handleUploadImage"
                :image="{ imageSrc: fields.media.image }"
                :height="`220`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveUpload"
              />
            </div>
            <div v-if="fields.media['show-video']">
              <label>Video URL</label>
              <v-text-field v-model="fields.media.video" :hide-details="true" class="mt-0" />
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';

export default {
  name: 'card-faq-kynorelle-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Left', value: 1 },
        { text: 'Right', value: 2 },
      ],
      fields: {
        title: 'Card FAQ Kynorelle Section',
        'card-container': '#FFFFFF',
        'text-color': '#000000',
        'top-padding': false,
        'bottom-padding': false,
        'container-page': {
          'show-style': false,
          background: '#FFFFFF',
        },
        'card-item-content': 1,
        'card-item-image': 2,
        'style-center-y': false,
        'content-title': {
          show: true,
          heading: '',
          description: '',
        },
        accordions: {
          show: true,
          items: [{ title: '', text: '' }],
        },
        button: {
          show: true,
          text: 'SHOP NOW',
          link: '#',
          background: '#003568',
          color: '#ffffff',
          radius: '4',
        },
        media: {
          'show-image': true,
          image: '',
          'show-video': false,
          video: '',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      'container-page': {
        ...this.fields['container-page'],
        ...(this.sectionEditor.sectionExtract['container-page'] || {}),
      },
      'content-title': {
        ...this.fields['content-title'],
        ...(this.sectionEditor.sectionExtract['content-title'] || {}),
      },
      accordions: {
        ...this.fields.accordions,
        ...(this.sectionEditor.sectionExtract.accordions || {}),
      },
      button: {
        ...this.fields.button,
        ...(this.sectionEditor.sectionExtract.button || {}),
      },
      media: {
        ...this.fields.media,
        ...(this.sectionEditor.sectionExtract.media || {}),
      },
    };

    if (!this.fields.accordions.items || !this.fields.accordions.items.length) {
      this.fields.accordions.items = [{ title: '', text: '' }];
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardFaqKynorelle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangePosition(value) {
      this.fields['card-item-image'] = Number(value);
      this.fields['card-item-content'] = Number(value) === 1 ? 2 : 1;
    },
    handleAddAccordion() {
      this.fields.accordions.items.push({
        title: '',
        text: '',
      });
    },
    handleRemoveAccordion(index) {
      if (this.fields.accordions.items.length <= 1) return;
      this.fields.accordions.items.splice(index, 1);
    },
    handleChangeMediaType(type) {
      const isImage = type === 'image';
      this.fields.media['show-image'] = isImage;
      this.fields.media['show-video'] = !isImage;
      if (isImage) {
        this.fields.media.video = '';
      } else {
        this.fields.media.image = '';
      }
    },
    handleUploadImage(obj) {
      this.fields.media.image = obj.imageSrc;
    },
    handleRemoveUpload() {
      this.fields.media.image = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
